import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App.tsx'
import { AlbumPage } from '@/pages/Album.page.tsx'
import { DrivePage } from '@/pages/Drive.page.tsx'
import SettingsPage from '@/pages/Settings.page.tsx'
import GamesPage from '@/pages/Games.page.tsx'
import DemoPage from '@/pages/Demo.page.tsx'
import LiveshowPage from '@/pages/Liveshow.page.tsx'
import YesIDoPage from '@/pages/YesIDo.page.tsx'
import OnboardingPage from '@/pages/Onboarding.page.tsx'
import GenericDrivePage from '@/pages/GenericDrive.page.tsx'
import GamePage from '@/pages/Game.page.tsx'
import GamesOverviewPage from '@/pages/GameOverview.page.tsx'
import ShopPage, { ShopPageContent } from '@/pages/Shop.page.tsx'
import ShopProductPage from '@/pages/ShopProduct.page.tsx'
import OrderItemPage from '@/pages/OrderItem.page.tsx'
import PrintPage from '@/pages/Print.page.tsx'
import PrintDeliveryPage from '@/pages/PrintDelivery.page.tsx'
import PaymentSuccessPage from '@/pages/PaymentSuccess.page.tsx'
import StorageDurationPage from '@/pages/StorageDuration.page.tsx'
import StripePaymentSuccessPage from '@/pages/StripePaymentSuccess.page.tsx'
import ActivatePage from '@/pages/Activate.page.tsx'
import GuestbookPage from '@/pages/Guestbook.page.tsx'
import ProductPage from '@/pages/Product.page.tsx'
import ProductSelectPhotoPage from '@/pages/ProductSelectPhoto.page.tsx'
import ProductPhotoCropPage from '@/pages/ProductPhotoCropPage.page.tsx'
import BasketPage from '@/pages/Basket.page.tsx'
import BasketEditOrderItemPage from '@/pages/BasketEditOrderItem.page.tsx'
import BasketEditSelectPhotosPage from '@/pages/BasketEditSelectPhotos.page.tsx'
import BasketEditCropPhotosPage from '@/pages/BasketEditCropPhotos.page.tsx'
import CheckoutPage from '@/pages/Checkout.page.tsx'
import OrdersPage from '@/pages/Orders.page.tsx'
import OrderDetailPage from '@/pages/OrderDetail.page.tsx'
import DriveCardEditorPage from '@/pages/DriveCardEditor.page.tsx';
import CardsPage from '@/pages/Cards.page.tsx'
import CardTemplatePage from '@/pages/CardTemplate.page.tsx'
import { SharedPage } from '@/pages/Shared.page.tsx'
import PortalDemoPage from '@/pages/portal/PortalDemo.page.tsx'
import PortalLoginPage from '@/pages/portal/PortalLogin.page.tsx'
import PortalOnboardingPage from '@/pages/portal/Onboarding.page.tsx'
import PortalPage from '@/pages/portal/Portal.page.tsx'
import DashboardPage from '@/pages/portal/Dashboard.page.tsx'
import ProjectsPage from '@/pages/portal/Projects.page.tsx'
import PortalStatsPage from '@/pages/portal/Stats.page.tsx'
import ProjectDetailPage from '@/pages/portal/ProjectDetail.page.tsx'
import SelectionDetailPage from '@/pages/portal/SelectionDetail.page.tsx'
import ProjectWatermarksPage from '@/pages/portal/ProjectWatermarks.page.tsx'
import PortalSettingsPage from '@/pages/portal/Settings.page.tsx'
import SubscriptionPage from '@/pages/portal/Subscription.page.tsx'
import PortalShopPage from '@/pages/portal/Shop.page.tsx'
import PriceListDetailPage from '@/pages/portal/PriceListDetail.page.tsx'
import TutorialsPage from '@/pages/portal/Tutorials.page.tsx'
import PortfoliosPage from '@/pages/portal/Portfolios.page.tsx'
import PortfolioDetailPage from '@/pages/portal/PortfolioDetail.page.tsx'
import { PortfolioPage } from '@/pages/Portfolio.page.tsx'
import { PortfolioProjectPage } from '@/pages/PortfolioProject.page.tsx'

const albumRoutes = [
  {
    path: '',
    element: <AlbumPage />,
  },
  {
    path: 'settings',
    element: <SettingsPage />
  },
  {
    path: 'game/',
    element: <GamesPage />,
    children: [
      {
        path: '',
        element: <GamesOverviewPage />,
      },
      {
        path: ':gameId/',
        element: <GamePage />,
      }
    ],
  },
  {
    path: 'guestbook',
    element: <GuestbookPage />,
  },
  {
    path: 'liveshow',
    element: <LiveshowPage />
  },
  {
    path: 'yes',
    element: <YesIDoPage />,
  },
  {
    path: 'shop',
    element: <ShopPage />,
    children: [
      {
        path: '',
        element: <ShopPageContent />,
      },
      {
        path: 'basket',
        element: <BasketPage />,
      },
      {
        path: 'basket/checkout',
        element: <CheckoutPage />,
      },
      {
        path: 'orders',
        element: <OrdersPage />,
      },
      {
        path: 'orders/:orderId',
        element: <OrderDetailPage />,
      },
      {
        path: 'basket/edit/:orderItemId',
        element: <BasketEditOrderItemPage />,
      },
      {
        path: 'basket/edit/:orderItemId/select-photos',
        element: <BasketEditSelectPhotosPage />,
      },
      {
        path: 'basket/edit/:orderItemId/crop-photos',
        element: <BasketEditCropPhotosPage />,
      },
      {
        path: 'product/:product_sku/:sku_suffix/select',
        element: <ProductSelectPhotoPage />,
      },
      {
        path: 'product/:product_sku/:sku_suffix/select/crop-photos',
        element: <ProductPhotoCropPage />,
      },
      {
        path: 'product/:product_sku',
        element: <ProductPage />,
      },
      {
        path: 'item/:orderItemId',
        element: <OrderItemPage />,
      },
      {
        path: ':productId',
        element: <ShopProductPage />,
      },
    ],
  },
]

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/s/:shareId',
    element: <SharedPage />,
  },
  {
    path: '/s/:shareId/:shareAlbumId',
    element: <SharedPage />,
  },
  {
    path: '/d/:driveId',
    element: <DrivePage />,
    children: [
      {
        path: '',
        element: <GenericDrivePage />,
        children: [
          {
            path: ':albumId',
            children: albumRoutes,
          },
          ...albumRoutes,
          {
            path: 'onboarding',
            element: <OnboardingPage />,
          },
          {
            path: 'upgrade_success',
            element: <PaymentSuccessPage />,
          },
          {
            path: 'payment_success',
            element: <StripePaymentSuccessPage />,
          },
          {
            path: 'storage',
            element: <StorageDurationPage />,
          },
          {
            path: 'cards',
            element: <CardsPage />
          },
          {
            path: 'cards/:cardId',
            element: <CardTemplatePage />
          },
          {
            path: 'card',
            element: <DriveCardEditorPage />
          },
        ],
      },
    ],
  },
  {
    path: 'portal/demo',
    element: <PortalDemoPage />,
  },
  {
    path: 'portal/login',
    element: <PortalLoginPage />,
  },
  {
    path: 'portal/onboarding',
    element: <PortalOnboardingPage />,
  },
  {
    path: 'portal',
    element: <PortalPage />,
    children: [
      {
        path: 'dashboard',
        element: <DashboardPage />,
      },
      {
        path: 'projects',
        element: <ProjectsPage />,
      },
      {
        path: 'projects/:projectId',
        element: <ProjectDetailPage />,
      },
      {
        path: 'projects/:projectId/selections/:selectionId',
        element: <SelectionDetailPage />,
      },
      {
        path: 'projects/:projectId/watermarks',
        element: <ProjectWatermarksPage />,
      },
      {
        path: 'projects/:projectId/selections/:selectionId/:selectionAlbumId',
        element: <SelectionDetailPage />,
      },
      {
        path: 'portfolios',
        element: <PortfoliosPage />,
      },
      {
        path: 'statistiken',
        element: <PortalStatsPage />,
      },
      {
        path: 'portfolios/:portfolioId',
        element: <PortfolioDetailPage />,
      },
      {
        path: 'shop',
        element: <PortalShopPage />,
      },
      {
        path: 'shop/:priceListId',
        element: <PriceListDetailPage />,
      },
      {
        path: 'subscription',
        element: <SubscriptionPage />,
      },
      {
        path: 'settings',
        element: <PortalSettingsPage />,
      },
      {
        path: 'tutorials',
        element: <TutorialsPage />,
      },
    ]
  },
  {
    path: '/p/:portfolioId',
    element: <PortfolioPage />,
  },
  {
    path: '/p/:portfolioId/:projectId',
    element: <PortfolioProjectPage />,
  },
  {
    path: '/p/:portfolioId/:projectId/:albumId',
    element: <PortfolioProjectPage />,
  },
  {
    path: 'demo',
    element: <DemoPage />,
  },
  {
    path: 'aktivieren',
    element: <ActivatePage />,
  },
  {
    path: 'print',
    element: <PrintPage />,
    children: [
      {
        path: 'delivery/:deliveryId',
        element: <PrintDeliveryPage />,
      }
    ],
  }
]);

export function Router() {
  return <RouterProvider router={router} />;
}
